/* eslint-disable array-callback-return */
/* eslint-disable react/destructuring-assignment */
import { Deviations } from './deviations';
import { Header } from './header';
import { ReportContext } from './hooks/use-context';
import { InitialInfos } from './initial-infos';
import type {
  EventReportData,
  ParsedQuestions,
  QuestionsReporData,
} from './types';

export function GoiasaDeviationsReport(props: { reportData: EventReportData }) {
  // Question ID mapping
  const QUESTIONS_MAP: Record<string, keyof ParsedQuestions> = {
    // Informações
    '462508f3-212e-4067-8c7f-1593b6be402c': 'tipo_inspecao',
    '617d7c9b-aebf-429c-af7b-05c065895f5c': 'participante',
    '114fb89f-e4d8-4bc4-a24a-cb8b826d91b2': 'area',
    'd383c3e2-df9c-4d0c-a56c-43b620ebc897': 'local',
    'f53ea725-98bb-4a39-ba3c-9907940be7c4': 'responsavel_area',

    // Desvios
    'ea59e666-9ada-45a6-9af2-e9587fcaf8ed': 'has_risks', // Existem situações de risco na área?
    'dd3bacf4-6065-47b3-91b5-626dda6bb43a': 'justificativa', // Justifique
    '21880187-58c3-498f-841f-41273c852806': 'providencias', // Quais foram as providências?
    '4ab52bcb-a251-4988-831c-ee85cb37463b': 'fotos', // Tire fotos
  };

  const values = Array.isArray(props?.reportData?.body)
    ? props?.reportData?.body?.reduce((acc, item) => {
        item.sections?.forEach((section) =>
          section.questions.forEach((question) => {
            if (question?.question_id && QUESTIONS_MAP[question.question_id]) {
              acc[QUESTIONS_MAP[question.question_id]] = question;
            }

            // Checks for child questions mapping
            if (question?.child_questions) {
              question.child_questions.forEach((child) => {
                if (child?.question_id && QUESTIONS_MAP[child.question_id]) {
                  acc[QUESTIONS_MAP[child.question_id]] = child;
                }
              });
            }
          }),
        );
        return acc;
      }, {} as Partial<ParsedQuestions>)
    : {};

  // For flat structure where the child questions might be listed separately in the section
  // we handled it in the section.questions.forEach

  const parsedProps: QuestionsReporData = {
    header: props?.reportData?.header,
    body: (values as unknown) as ParsedQuestions,
  };

  return (
    <ReportContext value={parsedProps}>
      <div>
        <div
          style={{
            height: '90%',
            width: '100vw',
            flex: 1,
            backgroundColor: 'white',
            fontFamily: 'sans-serif',
          }}
        >
          <div
            style={{
              margin: '1rem auto',
              height: 'auto',
              maxWidth: '64rem',
            }}
          >
            <Header formName="Registro de Desvios" />
            <div
              style={{
                height: '100%',
                width: '100%',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: '#000',
                backgroundColor: '#fff',
                padding: '1rem',
              }}
            >
              <InitialInfos />
              <Deviations />
            </div>
          </div>
        </div>
      </div>
    </ReportContext>
  );
}
